module.exports = __webpack_public_path__ + "static/media/3.83f167b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/3.png
// module id = 1519
// module chunks = 0